import type { SearchAlgoliaNycParksHit } from '#/modules/search/algolia/types/SearchAlgoliaNycParksHit';

export const EVENT_IMPORTED_TYPE_MAP: Record<
  SearchAlgoliaNycParksHit['source'],
  string
> = {
  NYCPARKS: 'NYC Parks',
};
